module.exports = "images/doc-currency-add.cf10b776825faa4b8b55e7bfcb9e5725.png";